import SubsidiaryAndParent from './SubsidiaryAndParent'

export default SubsidiaryAndParent
